import { Backdrop } from '@mui/material'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'

const ModalBackdrop = ({ open }: { open: boolean }) => (
    <Backdrop
        sx={{
            color: '#fff',
            zIndex: 3,
            borderRadius: 'inherit',
        }}
        open={open}
    >
        {/* <CircularProgress sx={{ color: styles.primaryYellow500 }} /> */}
        <LoadingSpinner />
    </Backdrop>
)

export default ModalBackdrop
